import React, { createContext, useContext, useState, useEffect } from 'react';

export interface WebSocketEvent {
  type: 'heartbeat' | 'status_change' | 'alert_new' | 'sim_telemetry';
  deviceId?: string;
  payload: any;
  timestamp: string;
}

interface WebSocketContextType {
  isConnected: boolean;
  lastEvent: WebSocketEvent | null;
  sendMockPing: () => void;
}

const WebSocketContext = createContext<WebSocketContextType | undefined>(undefined);

export const WebSocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isConnected, setIsConnected] = useState<boolean>(true);
  const [lastEvent, setLastEvent] = useState<WebSocketEvent | null>(null);

  useEffect(() => {
    // Periodic live telemetry simulation
    const interval = setInterval(() => {
      const mockEvent: WebSocketEvent = {
        type: 'heartbeat',
        deviceId: 'cam-002',
        payload: { signalDbm: -72 + Math.floor(Math.random() * 4 - 2), fps: 25 },
        timestamp: new Date().toISOString(),
      };
      setLastEvent(mockEvent);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const sendMockPing = () => {
    setLastEvent({
      type: 'heartbeat',
      deviceId: 'cam-004',
      payload: { ping: 'pong', latencyMs: 38 },
      timestamp: new Date().toISOString(),
    });
  };

  return (
    <WebSocketContext.Provider value={{ isConnected, lastEvent, sendMockPing }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within WebSocketProvider');
  }
  return context;
};
